import React from 'react'
import Container from '@material-ui/core/Container';

import Footer from '../../components/footer';
import Header from '../../components/header';

export default function App({ children }) {
  return (
    <>
      <Header />
      <Container>{children}</Container>
      <Footer />
    </>
  )
}
